<div class="title"><slot/></div>

<style>
	.title {
		font-size: 1.1em;
		font-weight: bold;
		margin-bottom: 10px;
	}
</style>